import ArrowUpRight from "./ArrowUpRight";

export default function CustomButton({
  nodeType = "a",
  style = "primary",
  label,
  icon = true,
  link,
  addon_class = "",
  disabled = false,
  onClick = () => {
    console.log("%cButton onClick not set...", "color: royalblue;");
  },
}) {
  const styles = {
    primary:
      "before:bg-rafa-red bg-rafa-red text-white hover:before:bg-white hover:text-black",
    secondary:
      "before:bg-white bg-rafa-red text-black hover:before:bg-rafa-red hover:text-white",
    "secondary-alt":
      "before:bg-white bg-rafa-red text-black hover:before:bg-white/20 hover:text-white",
  };

  const classes = [styles[style], addon_class].join(" ");

  switch (nodeType) {
    case "button":
      return (
        <button
          disabled={disabled}
          type="button"
          className={`w-fit flex justify-center items-center leading-none uppercase clipped-corner p-4 ${classes} ${!disabled ? "cursor-pointer" : "cursor-not-allowed !invisible"}`}
          onClick={onClick}
        >
          <label className="flex flex-row items-center gap-2 whitespace-nowrap">
            {label}
            {icon && <ArrowUpRight />}
          </label>
        </button>
      );

    case "a":
    default:
      return (
        <a
          className={`w-fit flex justify-center items-center leading-none uppercase clipped-corner p-4 ${classes}  ${!disabled ? "cursor-pointer" : "cursor-not-allowed"}`}
          href={link}
          disabled={disabled}
        >
          <label className="flex flex-row items-center gap-2 whitespace-nowrap">
            {label}
            {icon && <ArrowUpRight />}
          </label>
        </a>
      );
  }
}
